import $ from 'jquery';
import 'datatables.net';
$(document).ready(function () {

    var $secureAuthBlock = $('#secureAuthBlock');
    var $secureAuthLinkWrapper = $("#secureAuthLinkWrapper");
    var $secureAuthLink = $(".secureAuthLink");
    var $secureAuthLinkText = $secureAuthBlock.attr("data-ajax-linktext");


    //SIMPLE NUMBERS NO ELLIPSES EXTENSION FOR DATATABLE PAGINATION
    $.fn.DataTable.ext.pager.simple_numbers_no_ellipses = function (page, pages) {
        var numbers = [];
        var buttons = $.fn.DataTable.ext.pager.numbers_length = 5;
        var half = Math.floor(buttons / 2);

        var _range = function (len, start) {
            var end;

            if (typeof start === "undefined") {
                start = 0;
                end = len;

            } else {
                end = start;
                start = len;
            }
            var out = [];
            for (var i = start; i < end; i++) {
                out.push(i);
            }
            return out;
        };

        if (pages <= buttons) {
            numbers = _range(0, pages);

        } else if (page <= half) {
            numbers = _range(0, buttons);

        } else if (page >= pages - 1 - half) {
            numbers = _range(pages - buttons, pages);

        } else {
            numbers = _range(page - half, page + half + 1);
        }

        numbers.DT_el = 'span';

        return ['previous', numbers, 'next'];
    };

    //USER SERVICES
    if (!$(".block-userservices .servicelist").length > 0) {
        $('.site-header__backlink').removeClass('d-none');
    }

    $('#userTiclog').DataTable({
        "responsive": false,
        "lengthChange": false,
        "bLengthChange": false,
        "paging": false,
        "autoWidth": true,
        "pagingType": "simple_numbers",
        "pageLength": 10,
        "order": [],
        "columnDefs": [{
            "targets": 'no-sort',
            "orderable": false
        }]
    });
    var courseListElement = $("div[data-ajax-action]");
    if (courseListElement.length) {
        var ajaxActionUrl = courseListElement.attr("data-ajax-action");
        $.get({
            url: ajaxActionUrl,
            cache: false
        })
            .done(function (data) {
                if (data) {
                    $("#courseAnchorLink").show();
                    courseListElement.html(data);
                } else {
                    courseListElement.html(null);
                }
            })
            .fail(function () {
                courseListElement.html(null);
            });
    }


    if ($secureAuthBlock.length && $secureAuthLinkText.length) {
        $secureAuthLink.html($secureAuthLinkText);
        $secureAuthLinkWrapper.show();
        $secureAuthLink.on('click', function (e) {
            e.stopPropagation();
            $('html,body').animate({
                    scrollTop: $secureAuthBlock.offset().top - 50
                },
                '250');
        });
    }

    //NEW NAVIGATION + MOBILE
    $('.servicelist__link').each(function () {
        if ($(this).text().length > 18) {
            $(this).css("font-size", "1rem");
        } 
    });

    $(document).on('click', '.myservices__mobile__nav .nav-tabs li.active a', function () {
        $('.nav-tabs').toggleClass('open');
        $(".myservices__mobile__nav").removeClass('mobile__nav-up').addClass('mobile__nav-down');
    });
    $('.myservices__mobile__nav a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        $('.nav-tabs').removeClass('open');
    });

    $(".container-fluid.myservices__nav .nav-link").click(function () {
        $('html,body').animate({
                scrollTop: $('.tab-content').offset().top - 200
            },
            'slow');
    });
});
